// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Laod fontawesome
//import '@fortawesome/fontawesome-free/js/fontawesome'
//import '@fortawesome/fontawesome-free/js/solid'
//import '@fortawesome/fontawesome-free/js/regular'
//import '@fortawesome/fontawesome-free/js/brands'

//slick
import 'slick-carousel';
import 'bootstrap-touchspin';

// Load Styles
import '../scss/main.scss';

// Load Styles
import '../../assets/js/pro.min.js';

//jquery('.ssss').slick('slickAdd',"<div></div>");

(function( $ ) {
    // Use $ as usual here, e.g.:
    //$(".slider-1").slick();
    $('.presentation-slider').slick({
        dots: true,
        //infinite: true,
        //speed: 500,
        //slidesToShow: 1,
        //slidesToScroll: 1
    });
    $('.slider-partenaires').slick({
        dots: false,
        infinite: true,
        //speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:'<button type="button" class="slick-prev-2"><img src="/wp-content/themes/ecorystal/assets/images/chevron-right.png"></button>',
        nextArrow:'<button type="button" class="slick-next-2"><img src="/wp-content/themes/ecorystal/assets/images/chevron-left.png"></button>'
    });

    //quantity_618be47d66474
    $("input[name='quantity']").TouchSpin({
        verticalbuttons: true,
        //verticalupclass: '<i class="fas fa-chevron-up"></i>',
        //verticaldownclass: 'fas fa-chevron-up',
        verticalup: '<i class="fas fa-chevron-up"></i>',
        verticaldown: '<i class="fas fa-chevron-down"></i>',
    });
})( jQuery );
